import React, { createContext, useContext, useMemo } from 'react';
import { isServer } from '@/lib/constant';
import LxTracker, { LxTrackerContext } from '@/lib/lx';

type TrackerContextValue = LxTracker | null;

const TrackerContext = createContext<TrackerContextValue>(null);

export function TrackerProvider({ cid, context, children }: { cid: string; context?: LxTrackerContext; children: React.ReactNode }) {
  // SSR兼容性：服务端渲染时不创建 LxTracker 实例
  const tracker = useMemo(() => {
    if (isServer) {
      return null;
    }
    return new LxTracker(cid, context);
  }, [cid, context]);

  return <TrackerContext.Provider value={tracker}>{children}</TrackerContext.Provider>;
}

export function useTracker() {
  return useContext(TrackerContext);
}

export default TrackerContext;


